import * as types from '../constants/ActionTypes'
import DictionaryService from "../api/DictionaryService"

export function getRegions() {
  return (dispatch) => {
    console.log("[DICTIONARY] [try] Получение списка регионов...")
    DictionaryService.getRegions().then(response => {
      dispatch(setRegions(response.data.message))
    })
  }
}
export function setRegions(items) {
  console.log("[DICTIONARY] [success] Список регионов получен")
  return {
    type: types.SET_REGIONS,
    items
  }
}

export function getAllDSUsers() {
  return (dispatch) => {
    console.log("[DICTIONARY] [try] Получение списка пользоватей ДС...")

    DictionaryService.getAllDSUsers().then(response => {
      if (response.data.ok) {
        dispatch(setAllDSUsers(response.data.message))
      }
    })
  }
}

export function setAllDSUsers(users) {
  console.log("[DICTIONARY] [success] Список пользователей ДС получен")
  return {
    type: types.SET_USERS_DS,
    users
  }
}